import { createFileRoute } from '@tanstack/react-router'
import { AssetOverview } from 'pages/assetDatabase/assetOverview/AssetOverview'
import { AssetViews } from 'pages/assetDatabase/assetOverview/header/AssetHeader'
import { z } from 'zod'

const assetDetailsSearchSchema = z.object({
  view: z
    .enum(Object.values(AssetViews) as [string, ...string[]])
    .default(AssetViews.DETAILS),
  // Table state parameters
  sortBy: z.string().optional(),
  sortDesc: z.boolean().optional(),
  filters: z
    .record(
      z.string(),
      z.union([
        z.string(),
        z.number(),
        z.boolean(),
        z.array(z.string()),
        z.tuple([z.string().nullable(), z.string().nullable()]),
      ])
    )
    .optional(),
})

export const Route = createFileRoute('/assets/$siteID/$unitID')({
  component: RouteComponent,
  validateSearch: assetDetailsSearchSchema,
  staticData: {
    title: 'Asset Details',
  },
})

function RouteComponent() {
  return <AssetOverview />
}
